import React, { useState } from "react";
import { Button } from "antd";
import { FaUserMd, FaStethoscope } from "react-icons/fa";
import styles from "./DoctorCard.module.css";

const DoctorCard = ({ doctor, onBook }) => {
  const [imgError, setImgError] = useState(false);

  const handleClick = () => {
    onBook(doctor);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onBook(doctor);
    }
  };

  return (
    <div
      className={styles.card}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={`Đặt lịch với ${doctor.name}`}
    >
      <div className={styles.avatarWrap}>
        {!imgError ? (
          <img
            src={doctor.avatar}
            alt={doctor.name}
            className={styles.avatar}
            onError={() => setImgError(true)}
          />
        ) : (
          <FaUserMd className={styles.avatarIcon} />
        )}
      </div>

      <div className={styles.name}>{doctor.name}</div>
      <div className={styles.title}>{doctor.title}</div>
      <div className={styles.specialty}>{doctor.specialty}</div>

      <div className={styles.room}>
        <FaStethoscope className={styles.roomIcon} />
        <span>{doctor.room}</span>
      </div>

      {doctor.description && (
        <div className={styles.description}>{doctor.description}</div>
      )}

      <Button
        type="primary"
        className={styles.bookBtn}
        onClick={(e) => {
          e.stopPropagation();
          onBook(doctor);
        }}
      >
        Đặt lịch
      </Button>
    </div>
  );
};

export default DoctorCard;
